import { Component, OnInit, Inject } from '@angular/core';
import { StateService } from 'src/app/services/states.service';
import { AppService } from 'src/app/services/app.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-password',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.scss']
})
export class ResetpasswordDialog implements OnInit {
  user:any = "";
  resetpassForm: FormGroup = new FormGroup({});
  message:string = "";
  success:string = "";
  login: any;
  loading: boolean;
  id:any;
  isBetaTesteur : boolean = false;
  special:boolean = false;
  uppercase:boolean = false;
  integer:boolean = false;
  
  constructor(
    private stateService: StateService,
    private router: Router,
    private formBuilder: FormBuilder,
    private appService: AppService,
    public dialogRef: MatDialogRef<ResetpasswordDialog>,

    @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      this.login = this.data.login;
      this.id = this.data.id;
      this.isBetaTesteur = this.data.hasOwnProperty('isBetaTesteur') ? this.data.isBetaTesteur : false;
    
    }
 

  ngOnInit() {
    this.loading = true;
    this.resetpassForm = this.formBuilder.group({
      password: new FormControl(""),
      confpassword: new FormControl("")
    });
      this.appService.getEtatClient(this.login, this.id).subscribe((res)=>{
        console.log(res);
        if(res.result && res.result.typeerror){
          if (res.result.typeerror == "mdp") { // 
/*#2127 déplacé dans le homepage pour éviter d'avoir une popup "blink"
            if (this.isBetaTesteur) {
              this.router.navigateByUrl("/dossier");
              this.loading = false;
              this.dialogRef.close(); 
              return;
            }
            else {
*/
              this.message = "Oups, vous n'avez pas fait de demande de nouveau mot de passe."
//            }
          }
          else if (res.result.typerror == "token")
            this.message = "Oups, le compte client n'a pas été trouvé."
          else if (res.result.typerror == "compte")
            this.message = "Oups, le compte client n'a pas été trouvé."
          setTimeout (() => {
            this.router.navigateByUrl("/homepage");
            this.dialogRef.close(); 
          }, 5000);
        }else{
          this.loading = false;
        }
      })
  }

  submitNewPassword(){
    let res = this.resetpassForm.getRawValue();
    if(res.password === res.confpassword){
      this.appService.modifyPassword(this.login, res.password).subscribe((response)=>{
        if(response && response.result && response.result.success == true){
          this.success = "Votre mot de passe a bien été modifié.";
          // setTimeout (() => {
            this.router.navigateByUrl(this.isBetaTesteur ? "/dossier/post/" : "/homepage");
            this.dialogRef.close();
          // }, 5000);
        }
      })
    }else{this.message="Oups, les deux mots de passe sont différents";}
  }
  
  checkPassword(event){
    let regexInteger : RegExp = /[0-9]/;
    let regexUppercase : RegExp = /[A-Z]/;
    let regexSpecial : RegExp = /[^ \w]/;
    regexSpecial.test(event.target.value) ? this.special = true : this.special = false;
    regexUppercase.test(event.target.value) ? this.uppercase = true : this.uppercase = false;
    regexInteger.test(event.target.value) ? this.integer = true : this.integer = false;
  }

  checkInsert(){
    let form = this.resetpassForm.getRawValue();
    if(form.password != "" && form.password === form.confpassword && this.special && this.integer && this.uppercase) {
      return false;
    }else{return true;}
  }

  dismissDialog(){
    this.router.navigateByUrl("/homepage");
    this.dialogRef.close();
}
}
